export function isGroupMember(myGroups, group) {
  return myGroups.includes(group);
}
